import { createStyles, Card, TextInput, Text, Stack, Divider, Tabs, Group, Button, LoadingOverlay } from '@mantine/core';
import { DatePicker } from '@mantine/dates';
import { useForm } from '@mantine/form';
import { useEffect, useState } from 'react';
import * as Realm from "realm-web";
import { useNavigate, useParams } from 'react-router-dom';
import { Select } from '@mantine/core';
import { useBranches } from '../hooks/useBranches';
import { DropzoneButton } from '../components/DropZoneButton';
import { useListState } from '@mantine/hooks';
import { DndListHandle } from '../components/DndListHandle';
import { useQuality } from '../hooks/useQuality';
import { useBanners } from '../hooks/useBanners';


const useStyles = createStyles((theme) => ({
  card: {
    backgroundColor: theme.colorScheme === 'dark' ? theme.colors.dark[7] : theme.white,
  },
  title: {
    lineHeight: 1,
  },
}));

export function BannerEdit() {
  let { id } = useParams();
  const { classes } = useStyles();
  const navigate = useNavigate();
  const [visible, setVisible] = useState(false);
  const { save, getById, del } = useBanners();
  const [state, handlers] = useListState([]);
  const [edit, setEdit] = useState(false);

  const form = useForm({
    initialValues: {
      title: '',
    },
  });

  useEffect(() => {
    getById(id).then(exh => {
      if(exh) setEdit(true);
      form.setValues(exh);
      if(exh && exh.image_url) handlers.setState([exh.image_url])
    });
  }, [id])

  const addNewHall = async (values) => {
    setVisible(true);
    await save(
      {
        ...values, 
        _id: new Realm.BSON.ObjectID(),
        image_url: state.length ? state[0] : ''
      }
    )
    navigate('/banners');
  }

  const deleteBranch = () => {
    del(id);
    navigate('/banners');
  }


  return (
    <div style={{position: 'relative'}}>
    <Card withBorder radius="md" p="xl" className={classes.card}>
      <form onSubmit={form.onSubmit(addNewHall)}>

      <LoadingOverlay visible={visible} overlayBlur={2} />

      <Text size="xl" className={classes.title} weight={'bold'}>
        Салбар нэмэх
      </Text>
      <Divider my="sm" />
      <Stack>
        { state.length > 0 && <DndListHandle state={state} handlers={handlers} /> }
        <DropzoneButton state={state} handlers={handlers}/>

        <TextInput
          placeholder="Title"
          label="Title"
          withAsterisk
          {...form.getInputProps('title')}
        />
        <Divider my="sm" />

        <Button type='submit'>
          Хадгалах
        </Button>

       {edit && <Button color="red" onClick={deleteBranch}> 
          Устгах
        </Button>}

      </Stack>
    </form>
    </Card>
    </div>
  );
}